import { config } from './client-config';
import { logger } from './logger';
import { isImpersonating } from './impersonate-write-mode';

export function registerCloseBeacon(): (() => void) | undefined {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return undefined;

    let sent = false;
    const debug = config.closeBeaconDebug();

    // Opportunistically prefetch a Clerk session token (hook-less
    // `window.Clerk` read — there's no `getToken` prop available in this
    // non-React teardown context) so the teardown beacon can send it
    // synchronously.
    let cachedToken: string | null = null;
    const hydrateToken = async () => {
      try {
        const maybeClerk: any = (window as any).Clerk;
        const t = await maybeClerk?.session?.getToken?.();
        cachedToken = t && t.length > 0 ? t : null;
      } catch { cachedToken = cachedToken || null; }
    };
    void hydrateToken();

    const send = () => {
      if (sent || isImpersonating()) return;
      sent = true;
      try {
        let headerToken: string | null = cachedToken;
    if (debug) logger.debug({ hasToken: !!headerToken }, 'close-beacon: sending');
        // Prefer fetch with keepalive and cookies included
        if (typeof fetch === 'function') {
          try {
            const headers: Record<string, string> = {};
            if (headerToken) headers['Authorization'] = `Bearer ${headerToken}`;
            void fetch('/api/session/close', {
              method: 'POST',
              // keepalive during page teardown; cast to any for wide TS lib support
              keepalive: true,
              credentials: 'include',
              headers,
            } as any);
            return;
          } catch {}
        }
        // Fallback to sendBeacon when available
        if (typeof navigator !== 'undefined' && typeof (navigator as any).sendBeacon === 'function') {
          try { (navigator as any).sendBeacon('/api/session/close', ''); } catch {}
        }
      } catch {}
    };

    const onPageHide = () => send();
    const onVisibility = () => { if (document.visibilityState === 'hidden') send(); };

    window.addEventListener('pagehide', onPageHide, { capture: true } as any);
    document.addEventListener('visibilitychange', onVisibility, true);

    return () => {
      try { window.removeEventListener('pagehide', onPageHide, { capture: true } as any); } catch {}
      try { document.removeEventListener('visibilitychange', onVisibility, true); } catch {}
    };
  } catch {
    return undefined;
  }
}


